import { useAppDispatch, useAppSelector } from "../redux/store/hooks"
import {
    selectFulfilledOnboardingSteps,
    selectOnboardingIsRunningState,
    selectOnboardingStep,
    setOnboardingStep
} from "../redux/Onboarding"
import {
    OnboardingStepChapters,
    OnboardingStepOrder
} from "../onboarding/OnboardingStep"
import OnboardingContents from "../onboarding/OnboardingContents"
import SmallestHeadingComponent from "../component/SmallestHeadingComponent"
import { BlackLinkStyle } from "../component/Link"
import CheckIcon from "../icon/CheckIcon"
import IconResizer from "../icon/IconResizer"

function OnboardingStepMenu() {
    const onboardingIsRunning = useAppSelector(selectOnboardingIsRunningState)
    const currentStep = useAppSelector(selectOnboardingStep)
    const fulfilledSteps = useAppSelector(selectFulfilledOnboardingSteps)
    const dispatch = useAppDispatch()

    function setChapter(step: number) {
        console.log(`setting step to ${step}`)
        dispatch(setOnboardingStep(step))
    }

    return (
        <>
            {onboardingIsRunning && (
                <div
                    className={
                        "fixed w-[300px] overflow-y-scroll pb-10 bg-amber-300 top-[40px] left-0 bottom-[0] pl-[20px] flex flex-col space-y-4"
                    }>
                    <SmallestHeadingComponent>Kapitel</SmallestHeadingComponent>
                    {OnboardingStepChapters.map((chapter, index) => (
                        <div
                            key={`${index}`}
                            className={"flex flex-col space-y-2"}>
                            <div className={"font-bold"}>{chapter.chapter}</div>
                            {chapter.steps.map((step) => (
                                <div
                                    className={
                                        "ml-8 flex space-x-2 " +
                                        BlackLinkStyle +
                                        (step === currentStep
                                            ? " font-bold"
                                            : "")
                                    }
                                    key={OnboardingStepOrder.indexOf(step)}
                                    onClick={() =>
                                        setChapter(
                                            OnboardingStepOrder.indexOf(step)
                                        )
                                    }>
                                    <div>
                                        {fulfilledSteps.includes(step) ? (
                                            <div className={"ml-[-5px]"}>
                                                <IconResizer
                                                    size={20}
                                                    color={"text-green-600"}>
                                                    <CheckIcon />
                                                </IconResizer>
                                            </div>
                                        ) : (
                                            `${OnboardingStepOrder.indexOf(step) + 1}.`
                                        )}
                                    </div>
                                    <div>{OnboardingContents[step].title}</div>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            )}
        </>
    )
}

export default OnboardingStepMenu
